import { getStoredAccessToken } from '../../utils/regBranchOnLoadPayload';

const requestInterceptor = (configParam) => {
  const config = configParam;
  config.headers['request-startTime'] = new Date().getTime();

  const token = getStoredAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
};

export default requestInterceptor;
